import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

// Allow the larger of document vs image upload limits so profile/logo uploads (10 MB) are not blocked.
const sizeMb = Math.max(environment.maxFileSize || 5, environment.MAX_FILE_SIZE_MB || 10);
const MAX_FILE_SIZE = sizeMb * 1024 * 1024;

export const fileSizeInterceptor: HttpInterceptorFn = (req, next) => {
    // Check if the request is a file upload
    if (req.body instanceof FormData) {
        const formData = req.body;

        for (const [, value] of formData.entries()) {
            if (value instanceof File) {
                if (value.size > MAX_FILE_SIZE) {
                    return throwError(() => ({
                        error: {
                            error: `File ${value.name} exceeds the maximum size limit of ${sizeMb}MB`,
                        },
                    }));
                }
            }
        }
    }

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 413) {
                // Payload Too Large
                return throwError(() => ({
                    error: {
                        error: {
                            error: `The uploaded file is too large. Maximum size allowed is ${sizeMb}MB`,
                        },
                    },
                }));
            }
            return throwError(() => error);
        })
    );
};
